import React, { useEffect, useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box, makeStyles } from '@material-ui/core';

import { faqUrl, walkingUrl } from '../../../../globals';
import { getTotalVoted } from '../../../shared/services/ResultsService';
import Button from '../../../shared/components/Button';
import Counter from '../../../shared/components/Counter';
import Icon from '../../../shared/components/Icon';
import Image from '../../../shared/components/Image';
import IconPair from '../../../assets/images/icon-pair.svg';
import ImageNina from '../../../assets/images/go/nina-baginskaya.png';
import Loading from '../../../shared/components/Loading';
import Paragraph from '../../../shared/components/Paragraph';
import Separator from '../../../shared/structure/Separator';
import Section from '../../../shared/components/Section';
import ShareButtons from '../../../shared/components/ShareButtons';
import { SocialButtons } from '../../../shared/components/SocialButtons';
import SwipeableImageTabs from '../../../shared/components/SwipeableImageTabs';
import TwoCols from '../../../shared/structure/TwoCols';
import VoiceLink from '../../../shared/components/Link';
import WalkResultsBy960 from '../../../assets/images/go/walk-results-by-960.jpg';
import WalkResultsBy1440 from '../../../assets/images/go/walk-results-by-1440.jpg';
import WalkResultsBy1920 from '../../../assets/images/go/walk-results-by-1920.jpg';
import WalkResultsEu960 from '../../../assets/images/go/walk-results-eu-960.jpg';
import WalkResultsEu1440 from '../../../assets/images/go/walk-results-eu-1440.jpg';
import WalkResultsEu1920 from '../../../assets/images/go/walk-results-eu-1920.jpg';
import WalkResultsWorld960 from '../../../assets/images/go/walk-results-world-960.jpg';
import WalkResultsWorld1440 from '../../../assets/images/go/walk-results-world-1440.jpg';
import WalkResultsWorld1920 from '../../../assets/images/go/walk-results-world-1920.jpg';

const walkingResultConfig = [
  {
    id: 'belarus',
    title: 'walking_by',
    image: {
      srcDefault: {
        url: WalkResultsBy1440,
        width: 1440,
      },
      srcSet: [
        {
          url: WalkResultsBy960,
          width: 960,
        },
        {
          url: WalkResultsBy1920,
          width: 1920,
        },
      ],
    },
  },
  {
    id: 'europe',
    title: 'walking_eu',
    image: {
      srcDefault: {
        url: WalkResultsEu1440,
        width: 1440,
      },
      srcSet: [
        {
          url: WalkResultsEu960,
          width: 960,
        },
        {
          url: WalkResultsEu1920,
          width: 1920,
        },
      ],
    },
  },
  {
    id: 'world',
    title: 'walking_world',
    image: {
      srcDefault: {
        url: WalkResultsWorld1440,
        width: 1440,
      },
      srcSet: [
        {
          url: WalkResultsWorld960,
          width: 960,
        },
        {
          url: WalkResultsWorld1920,
          width: 1920,
        },
      ],
    },
  },
];

const useStyles = makeStyles((theme) => ({
  marginLeft: {
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
}));

export default function GoContainer() {
  const { t } = useTranslation();
  const [total, setTotal] = useState(null);
  const [totalLoaded, setTotalLoaded] = useState(false);
  const stepsRef = useRef(null);
  const classes = useStyles();

  const handleScrollToSteps = () => {
    console.log(55);
    stepsRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    getTotalVoted().then(
      (_totalVoted) => {
        setTotal(_totalVoted);
        setTotalLoaded(true);
      },
      () => {
        setTotalLoaded(true);
      },
    );
  }, []);

  return (
    <>
      <Section
        background="blue"
        title={t('walking_call_header')}
        button={(
          <Button
            background="white"
            onClick={handleScrollToSteps}
            text={`${t('walking_how_title')}?`}
          />
        )}
      />

      <Section
        background="gray"
        content={(
          <>
            <TwoCols
              alignItems="center"
              left={(
                <>
                  <Image src={ImageNina} alt={t('image_nina_alt')} />
                  <Paragraph>
                    {t('image_author')}
                    &nbsp;
                    <VoiceLink
                      href="https://www.instagram.com/rozan_art"
                    >
                      ROZAN_ART
                    </VoiceLink>
                  </Paragraph>
                </>
              )}
              right={(
                <>
                  <Box
                    ml={3}
                    className={classes.marginLeft}
                  >
                    {totalLoaded ? (
                      <Counter
                        title={t('go_counter_title')}
                        total={total.TotalWalking || 0}
                        color="blue"
                      />
                    ) : <Loading />}
                  </Box>
                </>
              )}
            />
          </>
        )}
      />

      <Section
        content={(
          <>
            <Paragraph>
              <Trans
                i18nKey="walking_result_p1"
                components={{ strong: <strong /> }}
              />
            </Paragraph>
            <Paragraph>
              {t('walking_result_p2')}
            </Paragraph>
            <Paragraph>
              {t('walking_result_p3')}
            </Paragraph>
            <Paragraph>
              <Trans
                i18nKey="walking_result_p4"
                components={{ strong: <strong /> }}
              />
            </Paragraph>
            <Paragraph>
              {t('walking_result_p5')}
            </Paragraph>
          </>
        )}
      />

      <Section
        title={t('go_last_title')}
        content={(
          <>
            <Paragraph>
              <Trans
                i18nKey="go_last_p1"
                components={{ strong: <strong /> }}
              />
            </Paragraph>
            <Paragraph>
              {t('go_last_p2')}
            </Paragraph>
          </>
        )}
      />

      <Separator background="blue" />

      <SwipeableImageTabs tabs={walkingResultConfig} />

      <Separator background="blue" />

      <Box ref={stepsRef} />

      <Section
        background="gray"
        title={t('walking_title_step_1')}
      />

      <Section
        content={(
          <TwoCols
            leftSpan={4}
            rightSpan={8}
            alignItems="stretch"
            leftJustifyContent="space-between"
            reverseSM
            left={(
              <>
                <SocialButtons flexDirection="column" />
                <Box>
                  <Paragraph>
                    {t('walking_how_desc_5')}
                  </Paragraph>
                  <ShareButtons
                    url={walkingUrl}
                    align="left"
                    share={['vk', 'facebook', 'odnoklassniki']}
                  />
                </Box>
              </>
            )}
            right={(
              <>
                <Paragraph title={t('walking_how_title')}>
                  <Trans
                    i18nKey="walking_how_desc_1"
                    components={{ bold: <strong /> }}
                  />
                </Paragraph>
                <Paragraph>
                  <Trans
                    i18nKey="walking_how_desc_2"
                    components={{ bold: <strong /> }}
                  />
                </Paragraph>
                <Paragraph>
                  <Trans
                    i18nKey="walking_how_desc_3"
                    components={{ bold: <strong /> }}
                  />
                </Paragraph>
                <Paragraph>
                  <Trans
                    i18nKey="walking_how_desc_4"
                    components={{ bold: <strong /> }}
                  />
                </Paragraph>
                <Paragraph>
                  <Trans
                    i18nKey="walking_how_desc_6"
                    components={{ bold: <strong /> }}
                  />
                </Paragraph>
                <Paragraph>
                  <Trans
                    i18nKey="walking_how_desc_7"
                    components={{ bold: <strong /> }}
                  />
                </Paragraph>
                <TwoCols
                  rightAlign="right"
                  left={(
                    <VoiceLink
                      bold={false}
                      small
                      href={`${faqUrl}?open=faq_group1_q6_title`}
                      underline="always"
                    >
                      {t('no_messenger')}
                    </VoiceLink>
                  )}
                  right={(
                    <VoiceLink
                      bold={false}
                      small
                      href={faqUrl}
                      underline="always"
                    >
                      {t('faq_answers')}
                    </VoiceLink>
                  )}
                />
              </>
            )}
          />
        )}
      />

      <Section
        background="gray"
        title={t('walking_title_step_2')}
      />

      <Section
        content={(
          <>
            <Paragraph title={t('walking_activate_bot')}>
              <Trans
                i18nKey="walking_activate_bot_desc_1"
                components={{ strong: <strong /> }}
              />
            </Paragraph>
            <Paragraph>
              {t('walking_activate_bot_desc_2')}
            </Paragraph>
            <Paragraph>
              {t('walking_activate_bot_desc_3')}
            </Paragraph>
          </>
        )}
      />

      <Section
        background="blue"
        title={t('walking_hashtag')}
      />

      <Section
        background="gray"
        title={t('walking_title_step_3')}
      />

      <Section
        content={(
          <TwoCols
            leftSpan={9}
            rightSpan={3}
            rightAlign="right"
            left={(
              <>
                <Paragraph title={t('walking_use_hashtag')}>
                  <Trans
                    i18nKey="walking_use_hashtag_desc_1"
                    components={{ strong: <strong /> }}
                  />
                </Paragraph>
                <Paragraph>
                  {t('walking_use_hashtag_desc_2')}
                </Paragraph>
              </>
            )}
            right={(
              <Icon
                src={IconPair}
                alt={t('polls_icon_pair')}
              />
            )}
          />
        )}
      />
    </>
  );
}
